module.exports = {
	"sorry": "findify-layouts--zero-results__sorry",
	"suggestionsRow": "findify-layouts--zero-results__suggestionsRow"
};